import { atom } from "jotai";

export const signIn = atom<boolean | null>(null)

export const userInfo = atom<any>({
  name: '',
  email: '',
  role: '',
})

export const selectedProductInfo = atom<any | null>(null)